export const useInputNumber = () => {
  const numberOnly = (event) => {
    const keyCode = (event.which) ? event.which : event.keyCode
    
    if(!event.target.value && keyCode == 48) {
      event.preventDefault()
    }

    if (keyCode > 31 && (keyCode < 48 || keyCode > 57)) {
      event.preventDefault()
    }
  }

  const numberDecimal = (event) => {
    const keyCode = event.which || event.keyCode
    const { value } = event.target

    if ([8, 9, 37, 38, 39, 40, 46].includes(keyCode)) return

    const key = String.fromCharCode(keyCode)

    if (!/[0-9,]/.test(key)) {
      event.preventDefault()
      return
    }

    if (key === ',' && value.includes(',')) {
      event.preventDefault()
    }
  }

  const npwpNumber = (event) => {
    const keyCode = (event.which) ? event.which : event.keyCode
    
    if (!event.target.value && (keyCode === 45 || keyCode === 46)) {
      event.preventDefault()
    }

    if (keyCode < 45 || keyCode > 57 || keyCode === 47) {
      event.preventDefault()
    }
  }

  const toNumber = (value) => {
    if(typeof value == 'number') return value
    return Number(value.replace(/[^0-9-]+/g, ""))
  }

  const toDecimalNumber = (value) => {
    if (!value) return 0
    const normalized = value.replace(/\./g, '').replace(',', '.')
    const parsed = parseFloat(normalized)
    return isNaN(parsed) ? 0 : parsed
  }

  return { numberOnly, numberDecimal, npwpNumber, toNumber, toDecimalNumber }
}
